import React from 'react';
import ProcurementOrderLines from './ProcurementOrderLines';
import ProcurementProductName from './ProcurementProductName';
import ProcurementOrdersToggle from './ProcurementOrdersToggle';

export default function ProcurementMobileView({ products, expandedProducts, onToggleExpand }) {
  return (
    <div className='procurement-cards'>
      {products.map(product => {
        const expanded = expandedProducts.includes(product.productId);
        return (
          <article className='card mb-3' key={product.productId}>
            <div className='card-body p-3'>
              <ProcurementProductName product={product} />
              <div className='mt-1'>
                <ProcurementOrdersToggle
                  product={product}
                  expanded={expanded}
                  onToggleExpand={onToggleExpand}
                />
              </div>
              <dl className='procurement-counts mt-3 mb-2'>
                <div>
                  <dt>Не забезпечено</dt>
                  <dd>{product.missingQuantity} шт</dd>
                </div>
                <div>
                  <dt>Вільно на складі</dt>
                  <dd>{product.freeStockQuantity} шт</dd>
                </div>
                <div>
                  <dt>Вже замовлено</dt>
                  <dd>{product.orderedQuantity} шт</dd>
                </div>
                <div>
                  <dt>Ще замовити</dt>
                  <dd className='text-danger'>{product.quantityToOrder} шт</dd>
                </div>
              </dl>
              {expanded && (
                <div
                  id={`procurement-orders-${product.productId}`}
                  className='procurement-mobile-orders'
                >
                  <ProcurementOrderLines orders={product.orders} />
                </div>
              )}
            </div>
          </article>
        );
      })}
    </div>
  );
}
